import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { Table, Badge, FormControl, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Alert, OverlayTrigger, Tooltip, Accordion, Modal } from 'react-bootstrap';
import { getFormErrorMsg, formattedDateInput, currencyFormat, getInvalidObject } from '../../../helper/Helper'
import { BrouillonService } from '../../../services/BrouillonService';
import { ReglementService } from '../../../services/ReglementService';
import ErrorManager from "../../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../../services/GlobalProvider";
import ConfirmDialog from '../../../components/confirm-dialog/ConfirmDialog';
import WysiwygInput from "../../../components/form-inputs/wysiwyg-input/WysiwygInput";


const ClientNom = (props) => {

    const [value, setValue] = useState()
    const [valueHasChanged, setValueHasChanged] = useState(false)

    useEffect(() => {
        valueHasChanged ? props.setIsComponentEditing(true) : props.setIsComponentEditing(false)
    }, [valueHasChanged]);

    useEffect(() => {
        if(props?.brouillon?.client_nom){
            setValue(props.brouillon.client_nom)
        }
    }, [props.brouillon]);

    function handleChange(e) {
        setValue(e.target.value)
        setValueHasChanged(true)
    }
    
    function cancel() {
        setValue(props.brouillon.client_nom)
        setValueHasChanged(false)
    }

    function save() {
        props.changeValue({
            target: {
                name: "client_nom",
                value: value
            }
        })
        setValueHasChanged(false)
    }

    return (
        <div className={((props.showChanges && props.modifiedValues?.client_nom) ? "modified-border" : "")}>
            <div className="d-flex align-items-center mb-3">
                <h6 className="text-dark d-flex align-items-center m-0">Nom du client</h6>
                {valueHasChanged &&
                    <span className="ms-auto">
                        <Button size="sm" variant="secondary" onClick={() => cancel()}>Annuler</Button>
                        <Button size="sm" className="ms-2" onClick={() => save()}>Enregistrer</Button>
                    </span>
                }
            </div>
            <Form.Group className={"ms-auto w-auto mb-2 mt-2 " + ((props.showChanges && props.modifiedValues?.client_nom) ? "modified-border" : "")}>
                <Form.Control value={value} placeholder="Nom du client" onChange={handleChange} name="client_nom"  isInvalid={getFormErrorMsg(props.invalidData?.client_nom)} type="text" />
                <Form.Control.Feedback type="invalid">{getFormErrorMsg(props.invalidData?.client_nom)}</Form.Control.Feedback>
            </Form.Group>
        </div>
    );
}

export default ClientNom;
